import { render, staticRenderFns } from "./TraxAccountRoleCrud.vue?vue&type=template&id=051488a1"
import script from "./TraxAccountRoleCrud.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports